import React, { useMemo } from 'react'

import OrderSerialNumbersList from '@shared/orders/OrderSerialNumbersList'
import ListPageHeader from '@shared/ListPageHeader'

import { orderService } from '@services/operator/orderService'

export default function OperatorOrderSerialNumbersList() {
  // Create a service wrapper that maps getSerialNumbers to getRecords
  // This is required because TableIndex expects a service with getRecords method
  const serialNumbersService = useMemo(() => ({
    getRecords: (params) => orderService.getSerialNumbers(params),
  }), [])

  return (
    <div>
      <ListPageHeader items={['orders', 'orders.serial_numbers']} />
      <OrderSerialNumbersList
        service={serialNumbersService}
        role="operator"
      />
    </div>
  )
}
